import { put, takeLatest, all, call } from 'redux-saga/effects';
import { setAction } from '../actions/billingPage';
import actionTypes from '../../../redux/actions/action-types';
import { getTeamSubscriptionSummaryWithTeamid } from '../../../api/cloudApiGenerated';

export function* getSummary(params) {
  let { team } = params.data;

  try {
    let data = yield call(getTeamSubscriptionSummaryWithTeamid, team.id);
    if (data.unitPrice > 0) data.unitPrice /= 100;
    if (data.priceTotal > 0) data.priceTotal /= 100;
    yield put(setAction({ data: data }));
  } catch (error) {
    yield put(
      setAction({
        error: 'loading plans: ' + error.message.join(' '),
      })
    );
  }
}

export function* watchGetSummary() {
  yield takeLatest(actionTypes.billingPage.getSummary, getSummary);
}

export default function* rootSaga() {
  yield all([watchGetSummary()]);
}
